import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "dropdown select-dropdown" }
const _hoisted_5 = {
  class: "dropdown-toggle border text-body rounded-2 bg-transparent",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "default-table-area style-two py-21 individual-asset-performance" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table align-middle" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_13 = ["src", "alt"]
const _hoisted_14 = { class: "fw-medium text-secondary fs-13" }
const _hoisted_15 = { class: "fw-normal fs-12 text-body" }
const _hoisted_16 = { class: "overflow-hidden" }
const _hoisted_17 = {
  class: "position-relative",
  style: {"top":"9px"}
}
const _hoisted_18 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_19 = { class: "fs-13" }
const _hoisted_20 = { "aria-label": "Page navigation example" }
const _hoisted_21 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_22 = { class: "page-item" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "page-item" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "mb-0" }, "Individual Asset Performance", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.selectedTimeRange), 1),
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRanges, (range) => {
              return (_openBlock(), _createElementBlock("li", { key: range }, [
                _createElementVNode("button", {
                  class: "dropdown-item text-secondary py-2 px-3",
                  onClick: ($event: any) => (_ctx.changeTimeRange(range))
                }, _toDisplayString(range), 9, _hoisted_7)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Asset"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Allocation %"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "ROI"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Current Value"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Net Gain/Loss"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "1D Change"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "7D Change"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-secondary"
                }, "Sparkline")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedAssets, (asset) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: asset.symbol
                }, [
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("img", {
                        src: asset.image,
                        style: {"max-width":"22px"},
                        alt: asset.name
                      }, null, 8, _hoisted_13),
                      _createElementVNode("span", _hoisted_14, [
                        _createTextVNode(_toDisplayString(asset.name) + " ", 1),
                        _createElementVNode("span", _hoisted_15, " (" + _toDisplayString(asset.symbol) + ") ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(asset.allocation) + "%", 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatPercentage(asset.roi)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(asset.currentValue)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(asset.netGain)), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getChangeClass(asset.oneDayChange))
                  }, _toDisplayString(_ctx.formatPercentage(asset.oneDayChange)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(_ctx.getChangeClass(asset.sevenDayChange))
                  }, _toDisplayString(_ctx.formatPercentage(asset.sevenDayChange)), 3),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.isClient)
                        ? (_openBlock(), _createBlock(_component_apexchart, {
                            key: 0,
                            type: "line",
                            height: "50",
                            width: "112",
                            options: _ctx.getChartOptions(asset),
                            series: _ctx.getChartSeries(asset)
                          }, null, 8, ["options", "series"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, " Showing " + _toDisplayString(_ctx.showingRange) + " of " + _toDisplayString(_ctx.assets.length) + " results ", 1),
          _createElementVNode("nav", _hoisted_20, [
            _createElementVNode("ul", _hoisted_21, [
              _createElementVNode("li", _hoisted_22, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_23)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_24)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_26)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}